module.exports = __webpack_public_path__ + "static/media/cancel.99867449.svg";